import { gql } from '@apollo/client'

export const ADD_MAGAZINE_ARTICLE = gql`
    mutation addMagazineArticle($input: addEntityInput!) {
        addEntity(input: $input) {
            success
            entity {
                guid
                ... on Blog {
                    title
                    url
                }
            }
        }
    }
`

export const EDIT_MAGAZINE_ARTICLE = gql`
    mutation editMagazineArticle($input: editEntityInput!) {
        editEntity(input: $input) {
            success
            entity {
                guid
                ... on Blog {
                    title
                    url
                }
            }
        }
    }
`
